export default __webpack_public_path__ + "images/PK.0e002e1.png";